import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const CustomerGroups = () => {
    document.title = "Müştəri qrupları";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Ayarlar", value: "/cash/settings" },
        { name: "Müştəri qrupları", value: "/cash/settings/customergroups", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Müştəri qrupları</h2>
                    <p>
                        Kassa proqramında görünəcək müştəri qruplarını müəyyənləşdirmək olar
                        <ol>
                            <li>
                                Kassa proqramında Ayarlar düyməsini sıxın, şifrəni daxil edib <Button>Enter</Button> düyməsi ilə ayarlara keçid edin
                            </li>
                            <li>
                                Açılan pəncərədə <b>Müştəri qrupları</b> seçimini edin
                            </li>
                            <li>
                                Daha sonra, kassa proqramında görünəcək <mark>müştəri qruplarını</mark> təyin edin və <SaveButton /> düyməsini sıxın.
                            </li>
                        </ol>
                    </p>
                    <img src="/images/cash/settings/customergroups.gif" alt="Müştəri qrupları" />
                </article>
            </div>
        </div>
    );
};
